import { Box, Button, Grid, Typography, Backdrop } from '@mui/material';
import TextField from '../../../../components/SanitizedTextField/SanitizedTextField';
import AppLoader from '../../../../components/AppLoader/AppLoader';
import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from "yup";
import "../../CreateOrganization.scss";
import { useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Select } from '@mui/material';
import { MenuItem } from '@mui/material';
import { cfpBaseUrl } from '../../../../network/urls';
import { allCFCLevelsAPI, allCompaniesAPI } from '../../../../services/Functions';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const SupportCenterCreateForm = () => {

  const initialValues = {
    iv_name: '',
    iv_code: '',
    iv_cfc_level: '',
    iv_company_code: '',
    iv_circle_code: '',
    iv_division_code: '',
    iv_subDivision_code: '',
    iv_address: '',
    iv_phone_no: '',
    iv_email: '',
    iv_status: "active",
    iv_assign_admin: '',
    iv_add_staffmember: '',

  }

  const [hierarchyList, setHierarchyList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);

  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [cfcLevelList, setCFCLevelList] = useState([]);
  const navigate = useNavigate();

  const { token, code: userOfficeCode, hierarchy } = useSelector((state) => state.auth)
  let userCompany = userOfficeCode.slice(0, 2);

  useEffect(() => {
    const callAllCompanies = async () => {
      setViewBackdrop(true)
      let companiesList = await allCompaniesAPI(token, cfpBaseUrl)
      if (companiesList) {
        companiesList = companiesList.filter(item => item.companyCode != 1)
        let cpList = companiesList.map(item => ({
          code: item.companyCode,
          name: item.companyName
        }))
        setCompanyList(cpList)
      }
      setViewBackdrop(false);
    }
    callAllCompanies()
  }, [])

  useEffect(() => {
    if (hierarchy != 1) {
      values.iv_company_code = userCompany
    }
  }, [hierarchy, userCompany])



  useEffect(() => {
    const callCFCLevels = async () => {
      setViewBackdrop(true)
      let cfcLevelsList = await allCFCLevelsAPI(token, cfpBaseUrl)
      if (cfcLevelsList) {
        if (hierarchy != 1) {
          cfcLevelsList = cfcLevelsList.filter(item => parseInt(item.cfcLevelId) >= parseInt(hierarchy))
        }
        setCFCLevelList(cfcLevelsList)
      }
      setViewBackdrop(false);
    }
    callCFCLevels()
  }, [])

  const handleChangeCompany = async (event) => {
    if (event) {
      handleChange(event);
      setViewBackdrop(true)
      const selectedCompany = companyList.find((item) => item.code === event.target.value); // find the selected circle object in the circleList array using the selected value
      values.iv_company_code = event.target.value;
      var formdata = new FormData();
      formdata.append("companyCode", selectedCompany.code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions)
        .then(response => response.json())
        .then(result => {
          let hierarchyArray = result.message
          let sortedSdArray = hierarchyArray.sort(function (a, b) {
            var sdA = a.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
            var sdB = b.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
            if (sdA < sdB) {
              return -1; // nameA comes before nameB in the sorted order
            }
            if (sdA > sdB) {
              return 1; // nameA comes after nameB in the sorted order
            }
            return 0; // names are equal, their order doesn't matter
          });
          setHierarchyList(sortedSdArray)
        }
        )
        .catch(() => {});
      setViewBackdrop(false)
    }
  };

  const handleChangeCFCLevel = (event) => {
    handleChange(event);
    if (hierarchy == 1) {
      values.iv_company_code = '';
      values.iv_circle_code = '';
      values.iv_division_code = '';
      values.iv_subDivision_code = '';
    } else {
      values.iv_company_code = userCompany;
      values.iv_circle_code = '';
      values.iv_division_code = '';
      values.iv_subDivision_code = '';
    }
  }

  useEffect(() => {
    if (userOfficeCode != 10) {
      values.iv_company_code = parseInt(userOfficeCode.toString().slice(0, 2))
    }
  }, [])

  // Formik form submission and new connection API calling
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: Yup.object({
        iv_name: Yup.string().required("Please enter Name"),
        iv_cfc_level: Yup.mixed().required("Please select CFC Level"),
        iv_code: Yup.string().optional("Please enter Code."),
        iv_company_code: Yup.mixed().optional("Please select Company"),
        iv_circle_code: Yup.mixed().optional("Please select Circle"),
        iv_division_code: Yup.mixed().optional("Please select Division"),
        iv_subDivision_code: Yup.mixed().optional("Please select Sub Division"),
        iv_address: Yup.string().required("Please enter Address."),
        iv_phone_no: Yup.string().min(11, "Phone no. can not less than 11 digits.").max(11, "Phone no. can not greater than 11 digits.").required("Phone no. is required").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone no. as 03001234567."),
        iv_email: Yup.string().email("Please enter valid Email.").required("Please enter Email."),
        iv_status: Yup.string().required('Select status')
      }),

      onSubmit: async (values, { resetForm }) => {
        setViewBackdrop(true)

        var formdata = new FormData();
        formdata.append("cfcName", values.iv_name);
        formdata.append("address", values.iv_address);
        formdata.append("phoneNo", values.iv_phone_no);
        formdata.append("cfcLevelId", values.iv_cfc_level);
        formdata.append("companyCode", values.iv_company_code);
        formdata.append("circleCode", values.iv_circle_code);
        formdata.append("divisionCode", values.iv_division_code); 
        // formdata.append("subdivisionCode", values.iv_subDivision_code); 

        formdata.append("subDivisionCode", values.iv_subDivision_code);  
        formdata.append("currentStatus", values.iv_status);
        formdata.append("email", values.iv_email);
        formdata.append("statusremarks", "");
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/addCFC", requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.status === '200') {
              resetForm();
              navigate('/support-center-management')
            }
            else {
            }
          })
        setViewBackdrop(false)
      }
    })

  useEffect(() => {
    const callSubDivApi = async () => {
      if (!values.iv_company_code) return;

      setViewBackdrop(true);

      const formdata = new FormData();
      formdata.append("companyCode", values.iv_company_code);

      const requestOptions = {
        method: "POST",
        body: formdata,
        headers: new Headers({ "Authorization": token }),
        redirect: "follow",
      };

      try {
        const response = await fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions);
        const result = await response.json();

        const sortedSdArray = result.message.sort((a, b) => (a.subDivisionName || '').toUpperCase() - (b.subDivisionName || '').toUpperCase());

        // Extract unique circle codes
        const uniqueCircleCodes = [...new Set(sortedSdArray.map(sd => sd.circleCode))];

        // Filter out duplicate circle names
        const circleList = uniqueCircleCodes.map(circleCode => {
          const circle = sortedSdArray.find(sd => sd.circleCode === circleCode);
          return { code: circleCode, name: circle.circleName };
        });

        setCircleList(circleList);

        const uniqueObjects = [...new Set(sortedSdArray)]

        setHierarchyList(uniqueObjects);
      } catch (error) {
      }
      setViewBackdrop(false);
    };

    callSubDivApi();
  }, [values.iv_company_code]);

  useEffect(() => {
    if (!hierarchyList || !values.iv_circle_code) return;

    const uniqueDivisions = hierarchyList
      .filter(division => division.circleCode === values.iv_circle_code)
      .reduce((uniqueDivisions, division) => {
        const existingDivision = uniqueDivisions.find(d => d.code === division.divisionCode);
        if (!existingDivision) {
          uniqueDivisions.push({
            code: division.divisionCode,
            name: division.divisionName,
          });
        }
        return uniqueDivisions;
      }, []);

    const sortedDivisionArray = uniqueDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setDivisionList(sortedDivisionArray);
  }, [values.iv_circle_code, hierarchyList]);

  useEffect(() => {
    if (!hierarchyList || !values.iv_division_code) return;

    const uniqueSubdivisions = hierarchyList
      .filter(subDiv => subDiv.divisionCode === values.iv_division_code)
      .reduce((uniqueSubdivisions, subDiv) => {
        const existing = uniqueSubdivisions.find(s => s.code === subDiv.subDivisionCode);
        if (!existing) {
          uniqueSubdivisions.push({
            code: subDiv.subDivisionCode,
            name: subDiv.subDivisionName,
          });
        }
        return uniqueSubdivisions;
      }, []);

    const sortedSubdivisionArray = uniqueSubdivisions.sort((a, b) =>
      a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })
    );

    setSubDivisionList(sortedSubdivisionArray);
  }, [values.iv_division_code, hierarchyList]);



  useEffect(() => {
  }, [values.iv_company_code])

  return (
    <>
      <Grid className='creation'>
        <Grid container className='creationContainer'>
          <Grid item lg={12}>
            <h3 className='heading'>
              Add Support Center
            </h3>
          </Grid>
          <Grid item lg={12} className='form'>
            <Grid container>
              <Grid item lg={12}>
                <Grid container spacing={1}>
                  <Grid item lg={12}>
                    <h4>Location</h4>
                  </Grid>
                  <Grid item lg={12}>
                    <Grid container>
                <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                  <Typography className='fieldLabel' >Level</Typography>
                  <Select
                    fullWidth
                    value={values.iv_cfc_level}
                    onChange={handleChangeCFCLevel}
                    onBlur={handleBlur}
                    // disabled={userOfficeCode != 10}
                    displayEmpty
                    sx={{ height: '45px' }}
                    className='dropdownList'
                    name="iv_cfc_level"
                    id="iv_cfc_level"
                  >
                    <MenuItem value='' >Select Level</MenuItem>
                    {
                      cfcLevelList.map(item => <MenuItem value={item.cfcLevelId}>{item.cfcLevelName}</MenuItem>)
                    }
                  </Select>
                  <Box sx={{ color: '#f73232', fontSize: '1rem' }}>
                    {errors.iv_company_code && touched.iv_company_code ? (errors.iv_company_code) : null}
                  </Box>
                </Grid>
                {
                  values.iv_cfc_level >= 2 &&
                  <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                    <Typography className='fieldLabel' >Company</Typography>
                    <Select
                      fullWidth
                      value={values.iv_company_code}
                      onChange={handleChangeCompany}
                      onBlur={handleBlur}
                      disabled={parseInt(hierarchy) != 1}
                      displayEmpty
                      sx={{ height: '45px' }}
                      className='dropdownList'
                      name="iv_company_code"
                      id="iv_company_code"
                    >
                      <MenuItem value='' >Select Company</MenuItem>
                      {
                        companyList.map(item => (
                          <MenuItem
                            key={item.code}
                            value={item.code}
                          >
                            {item.name}
                          </MenuItem>
                        ))
                      }
                    </Select>
                    <Box sx={{ color: '#f73232', fontSize: '1rem' }}>
                      {errors.iv_company_code && touched.iv_company_code ? (errors.iv_company_code) : null}
                    </Box>
                  </Grid>
                }
                {
                  values.iv_cfc_level >= 3 &&
                  <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                    <Typography className='fieldLabel' >Circle</Typography>
                    <Select
                      fullWidth
                      value={values.iv_circle_code}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      displayEmpty
                      sx={{ height: '45px' }}
                      className='dropdownList'
                      name='iv_circle_code'
                      id="select"
                    >
                      <MenuItem value="">Select Circle</MenuItem>
                      {
                        circleList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                      }
                    </Select>
                    <Box sx={{ color: '#f73232', fontSize: '1rem' }}>
                      {errors.iv_circle_code && touched.iv_circle_code ? (errors.iv_circle_code) : null}
                    </Box>
                  </Grid>
                }
                {
                  values.iv_cfc_level >= 4 &&
                  <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                    <Typography className='fieldLabel' >Division</Typography>
                    <Select
                      fullWidth
                      value={values.iv_division_code}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      displayEmpty
                      sx={{ height: '45px' }}
                      className='dropdownList'
                      name='iv_division_code'
                    >
                      <MenuItem value=''>Select Division</MenuItem>
                      {
                        divisionList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                      }
                    </Select>
                    <Box sx={{ color: '#f73232', fontSize: '1rem' }}>
                      {errors.iv_division_code && touched.iv_division_code ? (errors.iv_division_code) : null}
                    </Box>
                  </Grid>
                }
                {
                  values.iv_cfc_level >= 5 &&
                  <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                    <Typography className='fieldLabel' >Sub Division</Typography>
                    <Select
                      fullWidth
                      value={values.iv_subDivision_code}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      displayEmpty
                      sx={{ height: '45px' }}
                      className='dropdownList'
                      name='iv_subDivision_code'
                    >
                      <MenuItem value=''>Select Sub Division</MenuItem>
                      {
                        subDivisionList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                      }
                    </Select>
                    <Box sx={{ color: '#f73232', fontSize: '1rem' }}>
                      {errors.iv_division_code && touched.iv_division_code ? (errors.iv_division_code) : null}
                    </Box>
                  </Grid>
                }
                <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                  <Typography className='fieldLabel'>CFC Name</Typography>
                  < TextField name='iv_name'
                    required
                    type='text'
                    sx={{
                      width: '100%', '.MuiInputBase-input': {
                        height: '1vh',
                      },
                    }}
                    value={values.iv_name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    className='textInputField' />
                  <Box sx={{ color: '#f73232', fontSize: '1rem' }} >
                    {errors.iv_name && touched.iv_name ? (errors.iv_name) : null}
                  </Box>
                </Grid>
                <Grid item xs={values.iv_cfc_level >= 5 ? 6 : 3} sx={{ padding: '0px 10px' }}>
                  <Typography className='fieldLabel'  >Address</Typography>
                  <TextField
                    required
                    type='text'
                    name="iv_address"
                    fullWidth
                    value={values.iv_address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField'
                    sx={{
                      width: '100%', '.MuiInputBase-input': {
                        height: '1vh',
                      },
                    }}
                  />
                  <Box sx={{ color: '#f73232', fontSize: '1rem' }}>
                    {errors.iv_address && touched.iv_address ? (errors.iv_address) : null}
                  </Box>
                </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12}>
                <Grid container spacing={1}>
                  <Grid item lg={12}>
                    <h4>Contact</h4>
                  </Grid>
                  <Grid item lg={12}>
                    <Grid container>
                <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                  <Typography className='fieldLabel'>Phone No.</Typography>
                  <TextField
                    required
                    type="text"
                    name="iv_phone_no"
                    inputProps={{ maxLength: 11 }}
                    sx={{
                      width: '100%', '.MuiInputBase-input': {
                        height: '1vh',
                      },
                    }}
                    value={values.iv_phone_no}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField' />
                  <Box sx={{ color: '#f73232', fontSize: '1rem' }} >
                    {errors.iv_phone_no && touched.iv_phone_no ? (errors.iv_phone_no) : null}
                  </Box>
                </Grid>
                <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                  <Typography className='fieldLabel'  >Email</Typography>
                  <TextField
                    required
                    type='text'
                    name="iv_email"
                    sx={{
                      width: '100%', '.MuiInputBase-input': {
                        height: '1vh',
                      },
                    }}
                    value={values.iv_email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className='textInputField'
                  />
                  <Box sx={{ color: '#f73232', fontSize: '1rem' }}>
                    {errors.iv_email && touched.iv_email ? (errors.iv_email) : null}
                  </Box>
                </Grid>
                <Grid item xs={3} sx={{ padding: '0px 10px' }}>
                  <Typography className='fieldLabel'>Status</Typography>
                  <FormControl className='form-control'>
                    <RadioGroup
                      row
                      className='radio-group'
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={values.iv_status}
                      onChange={handleChange}>
                      <FormControlLabel value={"active"} className='form-control-label' control={<Radio />} label="Active" />
                      <FormControlLabel value={"inactive"} className='form-control-label' control={<Radio />} label="Inactive" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container className="org-form-actions">
                <Grid item lg={12} sx={{ textAlign: 'right' }}>
                  <Button variant="contained" size='medium' onClick={handleSubmit}>
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop >
    </>
  );
}

export default SupportCenterCreateForm;
